import React from 'react'
import PropTypes from 'prop-types'

import { getFriendlyStatus } from '../../utils/review'

const QuestStatus = props => (
  <div className={`quest-status ${props.status}`}>
    <div className={`quest-status-text ${props.status}`}>
      {getFriendlyStatus(props.status)}
    </div>
  </div>
)

QuestStatus.propTypes = {
  status: PropTypes.string.isRequired
}

export default QuestStatus



// WEBPACK FOOTER //
// ./src/components/mini/QuestStatus.js